const SectorWithGeo = [
  {
    label: 'Packaging',
    value: 'packaging',
    application: [
      {
        label: 'Food can',
        value: 'food-can',
        geography: [],
      },
      {
        label: 'Beverage can',
        value: 'beverage-can',
        geography: [],
      },
      {
        label: 'Closures',
        value: 'closures',
        geography: [],
      },
      {
        label: 'Cosmetics',
        value: 'cosmetics',
        geography: [],
      },
      {
        label: 'Foil stock',
        value: 'foil-stock',
        geography: [],
      },
    ],
  },
  {
    label: 'Automotive',
    value: 'automotive',
    application: [
      {
        label: 'Crash Management Systems',
        value: 'crash-management-systems',
        geography: [],
      },
      {
        label: 'Body Structures Components',
        value: 'body-structures-components',
        geography: [],
      },
      {
        label: 'Auto Body Sheet',
        value: 'auto-body-sheet',
        geography: [],
      },
      {
        label: 'Battery Applications',
        value: 'battery-applications',
        geography: [],
      },
      {
        label: 'Heat exchangers',
        value: 'heat-exchangers',
        geography: [],
      },
      {
        label: 'Decorative parts and trims',
        value: 'decorative-parts-and-trims',
        geography: [],
      },

      {
        label: 'Other automotive products',
        value: 'other-automotive-products',
        geography: [],
      },
    ],
  },
  {
    label: 'Aerospace',
    value: 'aerospace',
    application: [
      {
        label: 'Commercial aircraft',
        value: 'commercial-aircraft',
        geography: [
          {
            label: 'All',
            value: 'all',
          },
          {
            label: 'EMEA',
            value: 'emea',
          },
          {
            label: 'North America',
            value: 'na',
          },
          {
            label: 'Asia',
            value: 'asia',
          },
        ],
      },
      {
        label: 'Military aircraft',
        value: 'military-aircraft',
        geography: [
          {
            label: 'EMEA',
            value: 'emea',
          },
          {
            label: 'North America',
            value: 'na',
          },
          {
            label: 'Asia',
            value: 'asia',
          },
        ],
      },
      {
        label: 'Space',
        value: 'space',
        geography: [
          {label: 'EMEA', value: 'emea'},
          {label: 'North America', value: 'na'},
          {label: 'Asia', value: 'asia'},
        ],
      },
    ],
  },
  {
    label: 'Transportation',
    value: 'transportation',
    application: [
      {
        label: 'Rail',
        value: 'rail',
        geography: [],
      },
      {
        label: 'Bus',
        value: 'bus',
        geography: [],
      },
      {
        label: 'Commercial vehicles',
        value: 'commercial-vehicles',
        geography: [],
      },
      {
        label: 'Leisure vehicles',
        value: 'leisure-vehicles',
        geography: [],
      },
      {
        label: 'Marine',
        value: 'marine',
        geography: [],
      },
    ],
  },
  {
    label: 'Defense',
    value: 'defense',
    application: [
      {
        label: 'Military aircraft',
        value: 'military-aircraft',
        geography: [
          {label: 'EMEA', value: 'emea'},
          {label: 'North America', value: 'na'},
          {label: 'Asia', value: 'asia'},
        ],
      },
      {
        label: 'Armored vehicles',
        value: 'armored-vehicles',
        geography: [],
      },
    ],
  },

  {
    label: 'Industry',
    value: 'industry',
    application: [
      {
        label: 'Aluminium in electronics',
        value: 'aluminium-in-electronics',
        geography: [],
      },
      {
        label: 'Mechanical engineering',
        value: 'mechanical-engineering',
        geography: [],
      },
      {
        label: 'Aluminium molds',
        value: 'aluminium-molds',
        geography: [],
      },
      {
        label: 'Semiconductors and flat panels',
        value: 'semiconductors-and-flat-panels',
        geography: [],
      },
      {
        label: 'Profiles, tubes and bars',
        value: 'profiles-tubes-and-bars',
        geography: [],
      },
      {
        label: 'Sheets for industrial use',
        value: 'sheets-for-industrial-use',
        geography: [],
      },
      {
        label: 'Distribution',
        value: 'distribution',
        geography: [
          {label: 'Europe', value: 'europe'},
          {label: 'North America', value: 'na'},
          {label: 'Asia', value: 'asia'},
        ],
      },
      {
        label: 'Renewable energy',
        value: 'renewable-energy',
        geography: [],
      },
    ],
  },
  {
    label: 'Building & Construction',
    value: 'building',
    application: [
      {
        label: 'Solar energy',
        value: 'solar-energy',
        geography: [
          {
            label: 'Western Europe',
            value: 'we'
          },
          {
            label: 'Central Europe',
            value: 'ce'
          },
        ],
      },
      {
        label: 'Sheets and coils',
        value: 'sheets-coils',
        geography: [],
      },
      {
        label: 'Profiles, tubes and bars',
        value: 'profiles-tubes-and-bars',
        geography: [],
      },
      {
        label: 'Lighting applications',
        value: 'lighting-applications',
        geography: [],
      },
    ],
  },
  {
    label: 'Additive manufacturing',
    value: 'additive-manufacturing',
    application: [
      {
        label: '',
        geography: [],
      },
    ],
  },
]

export default SectorWithGeo
